import {
  clearCallSessionKeys,
  playCallEndSound,
  stopAllCallSounds,
} from "./callSounds";

let tearingDown = false;
let leaveNavigator: (() => void) | null = null;

export function isCallTearingDown() {
  return tearingDown;
}

export function setLeaveCallNavigator(fn: (() => void) | null) {
  leaveNavigator = fn;
}

export function beginCallTeardown() {
  if (tearingDown) return false;
  tearingDown = true;
  stopAllCallSounds();
  return true;
}

export function finishCallTeardown() {
  tearingDown = false;
}

export function leaveCallToChat() {
  playCallEndSound();
  if (leaveNavigator) {
    leaveNavigator();
    return;
  }
  if (typeof window !== "undefined") {
    window.history.replaceState(null, "", "/chat");
  }
}

export function idlePeerCallPatch() {
  return {
    call_id: 0,
    chat_id: "",
    room_id: "",
    peer_id: "",
    call_joined: false,
  };
}

/** After UI left /video-call — drop leftover keys. */
export function finalizeCallTeardown() {
  clearCallSessionKeys();
  window.setTimeout(() => {
    finishCallTeardown();
  }, 0);
}
